"use client"

import React, { useState } from "react"
import TemplateSelector from "./templateSelector"
import MinimalTemplate from "../Template/minimalTemplate"
import LuxuryTemplate from "../Template/luxuryTemplate"
import ModernTemplate from "../Template/modernTemplate"
import ClassicTemplate from "../Template/classicTemplate"
import VideoTemplate from "../Template/videoTemplate"
import SplitTemplate from "../Template/splitTemplate"

export default function CartScreen() {
  const [currentTemplate, setCurrentTemplate] = useState("video")

  const renderTemplate = () => {
    switch (currentTemplate) {
      case "minimal":
        return <MinimalTemplate />
      case "luxury":
        return <LuxuryTemplate />
      case "modern":
        return <ModernTemplate />
      case "classic":
        return <ClassicTemplate />
      case "video":
        return <VideoTemplate />
      case "split":
        return <SplitTemplate />
      default:
        return <MinimalTemplate />
    }
  }

  return (
    <div style={{ position: "relative" }}>
      <TemplateSelector
        currentTemplate={currentTemplate}
        onTemplateChange={setCurrentTemplate}
      />
      {renderTemplate()}
    </div>
  )
}